/**
 * @generated SignedSource<<9b933575c5de80b0596afc7a28942c8a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Image_item$data = {
  readonly description: string | null;
  readonly " $fragmentType": "Image_item";
};
export type Image_item$key = {
  readonly " $data"?: Image_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"Image_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Image_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7837a5e64b1b2f856919a6e924b293cf";

export default node;
